const getColor = (formComponents, checkboxLabel, hasError, dark, warning) => {
  if (checkboxLabel) {
    return dark ? formComponents.dark.color : formComponents.checkboxLabel.color;
  }

  if (hasError) {
    return dark
      ? warning ? formComponents.dark.warning.color : formComponents.dark.error.color
      : warning ? formComponents.warning.color : formComponents.error.color;
  }

  return dark ? formComponents.dark.color : formComponents.label.color;
};

export default ({ formComponents }) => ({
  optional: {
    float: 'right',
    marginRight: -5
  },
  root: ({
    checkboxLabel, dark, hasError, inline, textarea, warning
  }) => ({
    ...(checkboxLabel ? formComponents.checkboxLabel : formComponents.label),
    color: getColor(formComponents, checkboxLabel, hasError, dark, warning),
    lineHeight: (() => {
      if (inline) {
        const pixels = textarea
          ? formComponents.input.textareaHeight
          : formComponents.input.height;
        return `${pixels}px`;
      }
      return undefined;
    })()
  })
});
